<template>
  <div style="display: inline-block">
    <el-dropdown split-button type="danger" trigger="click">
      日志记录
      <el-dropdown-menu slot="dropdown" class="cargo-dropdown-menu" :style="{width:menuWidth+'px',height:menuHeight+'px'}">
        <sub-menu :menu-data="menuData" :menu-context="menuContext" :left-offset="menuItemWidth" :item-height="menuItemHeight" />
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import SubMenu from './subMenu'
import menuItem from './menuItem'
export default {
  name: 'CargoDropdownMenu',
  components: { menuItem, SubMenu },
  props: {
    menuItemWidth: { type: Number, default: 210 },
    menuItemHeight: { type: Number, default: 26 }
  },
  data() {
    return {
      menuContext: this,
      menuWidth: this.menuItemWidth,
      menuHeight: 5 * this.menuItemHeight,
      menuData: [
        { title: '一级',
          children: [
            { title: '1-1二级',
              children: [
                {
                  title: '1-1三级',
                  children: [
                    {
                      title: '1-1二级',
                      children: [
                        { title: '1-1三级' }
                      ]
                    }]
                },
                { title: '1-1三级' },
                { title: '1-1三级' },
                { title: '1-1三级' }
              ]
            }
          ]
        },
        { title: '2一级',
          children: [
            { title: '2-1二级' }
          ]
        }
      ]
    }
  },
  methods: {
    deduceMenuLayout({ currentLevel, maxChildrenCount }) {
      this.menuHeight = maxChildrenCount * this.menuItemHeight
      this.menuWidth = (currentLevel + 1) * this.menuItemWidth
    }
  }
}
</script>
<style lang="scss">
  .cargo-dropdown-menu {
    border: 1px solid #CCC; border-bottom:none;margin:50px auto;text-align: center;
    ul {
      list-style: none;
      margin: 0px;
      padding: 0px;
      li {
        background: #289CFF;
        color: #fff;
        padding: 0px 10px;
        height: 26px;
        line-height: 26px;
        border-bottom: 1px solid #CCC;
        position: relative;
        &:hover{background-color: #21B4BB}
        /*&:hover ul { display:block;}*/
        ul {
          position: absolute; top: 0px; border:1px solid #ccc; border-bottom:none;
          li{
            background-color: #21B4BB;
          }
        }
      }
    }
  }
</style>
